import {
    SF__SORT_FIELD,
    SF__QUERY_CHANGED,
    SF__SORT_DIRECTION,
    SF__FILTER_PRICE_RANGE,
    SF__FILTER_COLOR_TOGGLE,
    SF__FILTER_CATEGORY_TOGGLE,
    SF__FILTER_CATEGORY_ADDED,
    SF__FILTER_CATEGORY_CLEARED,
    SF_PAGINATE_CHANGE,
} from '../actions/action-types';
import SortDirectionType from "../enums/SortDirectionType";

const REACT_APP_MAX_PRICE_RANGE = 100000;

/**
 * initial state
 */
const INIT_STATE = {
    query: '',
    filters: {
        categories: [],
        colors: [],
        priceRange: {
            min: 0,
            max: REACT_APP_MAX_PRICE_RANGE,
        },
    },
    sort: {
        field: SortDirectionType.CREATION_DATE,
        direction: SortDirectionType.ASC,
    },
    pagination: {
        page: 1,
        size: 6
    }
};

export default (state = INIT_STATE, action) => {
    const newState = {...state};
    switch (action.type) {
        case SF__QUERY_CHANGED:
            return { ...state, query: action.payload};

        case SF__FILTER_CATEGORY_CLEARED:
            newState.filters.categories = [];
            return newState;

        case SF__FILTER_CATEGORY_ADDED:
            if (action.payload.clear) {
                newState.filters.categories = [];
            }
            action.payload.ids.forEach(catId => {
                if (!state.filters.categories.includes(catId)) {
                    newState.filters.categories.push(catId);
                }
            });
            return newState;

        case SF__FILTER_CATEGORY_TOGGLE:
            if (!state.filters.categories.includes(action.payload)) {
                newState.filters.categories.push(action.payload);
            } else {
                newState.filters.categories = newState.filters.categories.filter( item => item !== action.payload);
            }
            return newState;

        case SF__FILTER_COLOR_TOGGLE:
            if (!state.filters.colors.includes(action.payload)) {
                newState.filters.colors.push(action.payload);
            } else {
                newState.filters.colors = newState.filters.colors.filter( item => item !== action.payload);
            }
            return newState;

        case SF__FILTER_PRICE_RANGE:
            newState.filters.priceRange.min = action.payload.min;
            newState.filters.priceRange.max = action.payload.max;
            return newState;

        case SF_PAGINATE_CHANGE:
            newState.pagination.page = action.payload;
            return newState;

        case SF__SORT_FIELD:
            newState.sort.field = action.payload;
            return newState;

        case SF__SORT_DIRECTION:
            newState.sort.direction = action.payload;
            return newState;
        default:
            return state;
    }
}
